import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      closeButton
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4 text-success-fg" />,
        info: <InfoIcon className="size-4 text-info-fg" />,
        warning: <TriangleAlertIcon className="size-4 text-warning-fg" />,
        error: <OctagonXIcon className="size-4 text-destructive-fg" />,
        loading: <Loader2Icon className="size-4 animate-spin text-muted-foreground" />,
      }}
      toastOptions={{
        classNames: {
          toast: 'cn-toast font-sans',
          actionButton:
            '!bg-transparent !text-muted-foreground !px-0 underline underline-offset-4 hover:!text-foreground',
          success: '!bg-success !border-success-border',
          error: '!bg-destructive !border-destructive-border',
          info: '!bg-info !border-info-border',
          warning: '!bg-warning !border-warning-border',
          closeButton:
            '!top-1 !right-1 !left-auto !transform-none !bg-transparent !border-0 !shadow-none hover:!bg-black/5',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
